import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursorAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCursorAi"><Path d="M6.83824 5.02163L3.75 3.75L10 21L14.0441 14.0441L21 10.5L16.6176 9.04844" stroke="currentColor"/><Path d="M13.4 2H12.6L11.6 4.6L9 5.6V6.4L11.6 7.4L12.6 10H13.4L14.4 7.4L17 6.4V5.6L14.4 4.6L13.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursorAi;
